var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInboxOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 320H384L352 384H160L128 320H32C14.326 320 0 334.328 0 352V464C0 490.508 21.49 512 48 512H464C490.508 512 512 490.508 512 464V352C512 334.328 497.672 320 480 320ZM182.625 150.625L224 109.25V288C224 305.688 238.312 320 256 320S288 305.688 288 288V109.25L329.375 150.625C335.625 156.875 343.812 160 352 160S368.375 156.875 374.625 150.625C387.125 138.125 387.125 117.875 374.625 105.375L278.625 9.375C266.125 -3.125 245.875 -3.125 233.375 9.375L137.375 105.375C124.875 117.875 124.875 138.125 137.375 150.625S170.125 163.125 182.625 150.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxOut);
export default __webpack_public_path__ + "static/media/inbox-out.26f930046f6fe8391bdea122a0635433.svg";
export { ForwardRef as ReactComponent };